import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import PlanoModal from '../components/PlanoModal';
import LoginModal from '../components/LoginModal';

const FB_PROJ = 'migravip-e1afb';

export function useProtectedAction(exigePlano = true) {
  // contaUid é o dono da conta — o próprio usuário quando ele é o franqueado,
  // ou quem o convidou quando é equipe.
  const { user, contaUid, papel, pode }  = useAuth();
  const [showPlano, setShowPlano] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [temPlano, setTemPlano]   = useState(false);

  // ── Plano é DA CONTA, não de quem está logado ──────────────────────
  // Antes isto consultava planos/{user.uid}. Com equipe, o vendedor tem
  // uid próprio e nenhum plano no nome dele: toda tela dele diria "faça
  // seu plano". Quem assina é o franqueado, então é o plano dele que vale
  // para todo mundo que trabalha na conta.
  useEffect(() => {
    if (!user || !contaUid) { setTemPlano(false); return; }

    const verificar = async () => {
      try {
        const token = await user.getIdToken();
        const r = await fetch(
          `https://firestore.googleapis.com/v1/projects/${FB_PROJ}/databases/(default)/documents/planos/${contaUid}`,
          {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          }
        );
        if (!r.ok) { setTemPlano(false); return; }
        const data   = await r.json();
        const status = data.fields?.status?.stringValue || '';
        setTemPlano(status === 'ativo');
      } catch(e) {
        setTemPlano(false);
      }
    };

    verificar();
    // Reverifica a cada 30s (caso acabou de pagar)
    const interval = setInterval(verificar, 30000);
    return () => clearInterval(interval);
  }, [user, contaUid]);

  const protect = (fn) => (...args) => {
    if (!user)                    { setShowLogin(true); return; }
    if (exigePlano && !temPlano)  { setShowPlano(true); return; }
    return fn(...args);
  };

  const Modals = (
    <>
      {showPlano && (
        <PlanoModal
          onClose={() => setShowPlano(false)}
          onLogin={() => { setShowPlano(false); setShowLogin(true); }}
        />
      )}
      {showLogin && (
        <LoginModal onClose={() => setShowLogin(false)} />
      )}
    </>
  );

  // papel e pode() saem daqui também, para as telas que precisam esconder
  // um botão específico sem criar outra importação.
  return { protect, Modals, logado: !!user, temPlano, contaUid, papel, pode };
}
